<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Sarah Zettel Collection</h1>
<h2 class="center">Playing God, Reclamation, The Quiet Invasion, and Fool’s War</h2>
<h3 class="center" style="margin-top:50px;">Sarah Zettel</h3>
<p class="center" style="margin-top:80px;"><img alt="" src="v1/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?22cb7988